import BackButton from "../../../components/Buttons/BackButton";
import XsCont from "../../../components/containers/Xs";
import HeaderSignOut from "../../../components/headers/HeaderSignOut";
import { API_URL } from "../../../consts/ApiUrl";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Container, Typography, IconButton } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// ルックアッププラグインは本番未リリースのため、.env.* のフラグで環境ごとに表示を切り替える
const showLookupPlugin: boolean =
  process.env.REACT_APP_SHOW_LOOKUP_PLUGIN === "true";

const PluginDownloadPage: FC = () => {
  const navigate = useNavigate();
  const [pluginVersion, setPluginVersion] = useState<string>("1.0.0");
  const [pluginUrl, setPluginUrl] = useState<string>("");
  const [templateVersion, setTemplateVersion] = useState<string>("1.0.0");
  const [templateUrl, setTemplateUrl] = useState<string>("");
  const [lookupPluginVersion, setLookupPluginVersion] =
    useState<string>("1.0.0");
  const [lookupPluginUrl, setLookupPluginUrl] = useState<string>("");

  useEffect(() => {
    const fetchFileInfo = async (fileType: string) => {
      try {
        const idToken: string = sessionStorage.getItem("idToken") || "";
        const headers: Record<string, string> = {
          "Content-Type": "application/json",
          Authentication: idToken,
        };
        if (API_URL.DOWNLOAD_FILE.includes("ngrok-free.dev")) {
          headers["ngrok-skip-browser-warning"] = "true";
        }
        const response = await fetch(
          `${API_URL.DOWNLOAD_FILE}?file_type=${fileType}`,
          {
            method: "GET",
            headers,
          }
        );
        if (!response.ok) {
          if (response.status === 401) {
            navigate("/signin");
          } else {
            navigate("/error");
          }
          return;
        }
        const data = await response.json();
        const { url, version } = data.result;
        if (fileType === "plugin") {
          setPluginVersion(version);
          setPluginUrl(url);
        } else if (fileType === "template") {
          setTemplateVersion(version);
          setTemplateUrl(url);
        } else if (fileType === "lookup-plugin") {
          setLookupPluginVersion(version);
          setLookupPluginUrl(url);
        }
      } catch (error) {
        console.error("エラー:", error);
        navigate("/error");
      }
    };

    fetchFileInfo("plugin");
    fetchFileInfo("template");
    if (showLookupPlugin) {
      fetchFileInfo("lookup-plugin");
    }
  }, [navigate]);

  const handleDownload = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    } else {
      navigate("/error");
    }
  };

  const handleButtonClick = () => {
    navigate("/menu");
  };

  return (
    <>
      <HeaderSignOut />
      <Container maxWidth="lg">
        <Box mt={10} textAlign="center">
          <Typography variant="h4" gutterBottom>
            プラグインダウンロード
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={15}>
            プラグインバージョン: {pluginVersion}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={1}
            gap={1}
            ml={3}
          >
            <Typography variant="h6">plugin.zip</Typography>
            <IconButton
              color="primary"
              onClick={() => handleDownload(pluginUrl)}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
          <Typography variant="body1" color="textSecondary" mt={5}>
            テンプレートバージョン: {templateVersion}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={1}
            gap={1}
            ml={3}
          >
            <Typography variant="h6">template.zip</Typography>
            <IconButton
              color="primary"
              onClick={() => handleDownload(templateUrl)}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
          {showLookupPlugin && (
            <>
              <Typography variant="body1" color="textSecondary" mt={5}>
                ルックアッププラグインバージョン: {lookupPluginVersion}
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                mt={1}
                gap={1}
                ml={3}
              >
                <Typography variant="h6">lookup-plugin.zip</Typography>
                <IconButton
                  color="primary"
                  onClick={() => handleDownload(lookupPluginUrl)}
                >
                  <DownloadIcon />
                </IconButton>
              </Box>
              <Typography variant="body2" color="textSecondary" mt={1}>
                インストール後、アプリのプラグイン設定画面で認証キーを入力して保存してください。
              </Typography>
            </>
          )}
        </Box>
      </Container>
      <XsCont>
        <BackButton onClick={handleButtonClick} mt={15}>
          メニューに戻る
        </BackButton>
      </XsCont>
    </>
  );
};

export default PluginDownloadPage;
